import ButtonVariants from "@core-components/button/ButtonVariants";
import SSCarousel from "@core-components/carousel/Carousel";
import Emoji from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import EPublicRoutes from "@core-types/routes.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Stack } from "@mantine/core";
import type { ReactNode } from "react";
import { Trans } from "react-i18next";
import Review from "./Review";
import ReviewBanner from "./ReviewBanner";
import type { IReview } from "./model/IReview";

interface Props {
  reviews: IReview[];
  headline?: ReactNode;
  className?: string;
}

const ReviewCarousel = ({ reviews, className, headline }: Props) => {
  const { t } = useAppTranslation("common.reviews");

  const defaultHeadline = (
    <>
      <Emoji.ThumbUp size={20} />
      <Trans t={t} i18nKey="customer">
        <SSWhiteText> AVIS </SSWhiteText>
        <SSLoLGradientText>CLIENT</SSLoLGradientText>
      </Trans>
    </>
  );

  return (
    <Stack className={`w-full ${className}`} gap={0}>
      <Group className="px-2 sm:px-8" justify="space-between">
        <SSHeadline
          props={{
            title: {
              size: "h3",
            },
          }}
        >
          {headline ?? defaultHeadline}
        </SSHeadline>
        <ButtonVariants.SeeMore
          href={EPublicRoutes.REVIEWS}
          text="Tous les avis"
          title={t("viewAllTrustpilot")}
        />
      </Group>
      <SSCarousel autoPlay className="min-h-36">
        {reviews.map((review, index) => (
          <Review key={`${review.author}-${index}`} {...review} />
        ))}
      </SSCarousel>
      <ReviewBanner />
    </Stack>
  );
};

export default ReviewCarousel;
